import { createFileRoute, notFound } from '@tanstack/react-router';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { GuestLedger, LedgersView } from '@mews-commander/modules/src/modules/finance';
import { MewsTeam, RouteType } from '@mews/enums';
import { useFeatureFlag } from '@mews/framework';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Finance/Ledgers/Guest')({
    component: Component,
    beforeLoad: ({ context: { featureFlagService } }) => {
        const mewsGuestLedgerEnabled = featureFlagService.hasFlag(FeatureFlag.mewsGuestLedger);
        const goodDataLedgersEnabled = featureFlagService.hasFlag(FeatureFlag.newFinanceLedgersEnabled);

        if (!mewsGuestLedgerEnabled && !goodDataLedgersEnabled) {
            throw notFound();
        }
    },
    staticData: {
        owner: MewsTeam.Accounting,
        type: RouteType.Frontend,
        title: TextKey.GuestLedger,
    },
});

function Component() {
    const isNewGuestLedgerEnabled = useFeatureFlag(FeatureFlag.mewsGuestLedger);
    return isNewGuestLedgerEnabled ? <GuestLedger /> : <LedgersView activeTab={TextKey.GuestLedger} />;
}
